import { teamResumeStatsActions } from './actions';
import { TeamResumeStats } from './team-resume-stats';


export function teamResumeStatsReducer(state = new TeamResumeStats(), { payload, type }) {
    switch (type) {
        case teamResumeStatsActions.FETCH_TEAM_RESUME_STATS_SUCCESS:
            return state.merge({
                isPending: false,
                count_members: payload.data.count_members,
                count_mp: payload.data.count_mp,
                count_tt: payload.data.count_tt,
                progress_mp: payload.data.progress_mp,
                progress_tt: payload.data.progress_tt
            });
            
        case teamResumeStatsActions.FETCH_TEAM_RESUME_STATS_FAILED:
            return state.merge({
                isPending: false,
                error: payload?.error?.data
            });
        
        case teamResumeStatsActions.FETCH_TEAM_RESUME_STATS_PENDING:
            return state.set('isPending', true);

        case teamResumeStatsActions.LOAD_TEAM_RESUME_STATS:
            return state.set('team_id', Number(payload.team_id) || payload.team_id);

        default:
            return state;
    }
}


